import { customAxios as axios, getToken } from '../../request'
import { applyForCyprusFamTourAppUrl, cyprusFamTourAppUrl, interestForCyprusFamTourAppUrl } from './api'
import { notification } from 'antd'
import { hidePageLoad, showPageLoad } from '../../modules/actions'

export const cyprusFamTourAppFxn = async () => {
  let { data } = await axios.post(cyprusFamTourAppUrl(), {}, getToken())
  return data
}

export const applyForCyprusFamTourAppFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(applyForCyprusFamTourAppUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const interestForCyprusFamTourAppFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(interestForCyprusFamTourAppUrl(), valData)
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
